<template>
  <div
    class="center-vertical center-horizontal bg-radient-light"
    style="height: 100vh"
  >
    <button
      style="background-color: transparent; border: none; color: white"
      @click="goToHome()"
    >
      <h1>ENTER</h1>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    goToHome() {
      this.$emit("go-to-home");
    },
  },
};
</script>

<style></style>
